<template>
    <div class="library">
        <Header />
        <button class="btn-back" @click="$router.go(-1)">
            Voltar
        </button>
        <div class="library-container">
            <h2 class="title">Biblioteca Unimais</h2>
            <p class="subtitle">Pesquise por temas, trechos, palavras-chave, e encontre o seu material.📚</p>

            <Search />
            <!-- Lista de livros (cards) -->
            <h3 class="discipline">{{ disciplineName }}</h3>
            <div class="pdf-grid">
                <CardBook v-for="pdf in pdfs" :key="pdf.codigo_aula" :book="pdf" @details="viewDocumento" />
                <div v-if="pdfs.length === 0 && !loading" class="no-results">
                    Nenhum Livro encontrado.
                </div>
                <div v-if="loading" class="loading">
                    Carregando livros...  
                    <div v-if="loading" class="spinner"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../styles/Library.css';
import Header from '../components/Header.vue';
import CardBook from '../components/CardBook.vue';
import request from '../router/request';
import Search from '../components/Search.vue';
import token from '../scripts/token';

export default {
    name: "Classes",
    components: {
        Header,
        CardBook,
        Search,
    },
    data() {
        return {
            pdfs: [],
            loading: true,
            disciplineName: ''
        };
    },
    methods: {
        viewDocumento(item) {
            this.showModal = true;
            this.viewDoc = '';
            this.pdfLista = [];
            this.currentPDF = 0;
            this.objetoVisualizar = item;

            request.post("ava/obterAulasDiciplina", {
                codigo_disciplina: item.codigo_disciplina
            }).then(response => {
                if (!response.data || response.data.length === 0) {
                    console.log("Nenhum PDF encontrado para esta disciplina.");
                    return;
                }
                this.pdfLista = response.data;
                this.carregarPdfAtual();
            });
        },
        carregarPdfAtual() {
            const pdf = this.pdfLista[this.currentPDF];
            request.post("arquivo/prepararDownload", {
                ano_mes_dia_arq: pdf.amd_arq_pdf_aula,
                hash_arquivo: pdf.hash_arq_pdf_aula,
            }).then(resp => {
                this.viewDoc = "/api/arquivo/download?hash=" + resp.data.hash;
            });
        },
        mountCardBooks() {
            const codigo_disciplina = this.$route.query.discipline

            this.loading = true;
            request.post('ava/obterAulasDiciplina', { codigo_disciplina: codigo_disciplina })
                .then(response => {
                    const resultado = response.data;
                    let books = []; // Variável para armazenar a lista de livros

                    if (Array.isArray(resultado)) {
                        books = resultado;
                    } else if (resultado && Array.isArray(resultado.data)) {
                        books = resultado.data;
                    } else {
                        console.warn('Resposta inesperada para obterAulasDisciplina:', resultado);
                        this.pdfs = [];
                        return; // Sai da função se não houver dados
                    }

                    // Ordena os livros em ordem alfabética pelo nome do arquivo
                    books.sort((a, b) => {
                        const nameA = (a.nome_arquivo || '').toString().replace(/^[^a-zA-Z0-9À-ÿ]+/g, '').trim();
                        const nameB = (b.nome_arquivo || '').toString().replace(/^[^a-zA-Z0-9À-ÿ]+/g, '').trim();
                        return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base' });
                    });

                    this.pdfs = books;

                    // Captura o nome da disciplina do primeiro item, se houver
                    if (books.length > 0) {
                        this.disciplineName = books[0].nome_disciplina;
                        // ATENÇÃO: Verifique se o nome do campo é 'nome_disciplina'. 
                        // Pode ser 'disciplina', 'nome', etc. Ajuste se necessário.
                    }

                })
                .catch(err => {
                    console.error('Erro ao carregar livros:', err);
                    this.pdfs = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        token.validarToken();
        token.startTokenRefreshInterval();

        this.mountCardBooks();
    }
}
</script>